import { PageLayout } from "../components/PageLayout";

export default function AboutUsPage() {
  return (
    <PageLayout>
      <div className="container max-w-5xl py-12 space-y-8">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-center">
          About Us
        </h1>
        <p className="text-muted-foreground text-center max-w-2xl mx-auto">
          Learn more about the team behind {import.meta.env.VITE_APP_NAME}.
        </p>
      </div>
    </PageLayout>
  );
}
